import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react';
import type { Dispatch, SetStateAction } from 'react';
import React from 'react';

import { IconClose } from '@/assets';
import { Buttons } from '@/components';

import useRemoveAssetFromCollection from './useRemove';

const RemoveAsset: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  collectionId: number;
  assetId: number;
  setIsRemove: Dispatch<SetStateAction<boolean>>;
}> = ({ isOpen, onClose, collectionId, assetId, setIsRemove }) => {
  const { loading, handleRemoveAssetFromColleciton } = useRemoveAssetFromCollection();

  const onSubmit = async () => {
    await handleRemoveAssetFromColleciton(collectionId, assetId, setIsRemove);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      hideCloseButton
      scrollBehavior="inside"
      placement="center"
      onClose={onClose}
    >
      <ModalContent className="min-w-[400px] rounded-[32px] sm:min-w-0">
        <ModalHeader className="flex items-center justify-between p-10 pb-8">
          <span className="text-[24px] font-[600]">Remove artwork</span>
          <Buttons
            onClick={onClose}
            className="flex h-[32px] w-[32px] min-w-0 cursor-pointer items-center justify-center rounded-[8px] bg-gray-100 p-0"
          >
            <IconClose />
          </Buttons>
        </ModalHeader>
        <ModalBody className="max-h-[350px] px-[40px]">
          <div className="text-[16px] leading-[1.5] text-gray-500">
            Are you sure you want to remove this artwork from this collection?
          </div>
        </ModalBody>
        <ModalFooter className="mt-5 block p-0">
          <div className="flex items-center justify-end px-[40px] py-[30px]">
            <Buttons onClick={onClose} typeBtn="cancel">
              Cancel
            </Buttons>
            <Buttons isLoading={loading} onClick={onSubmit} className="ml-3">
              Confirm
            </Buttons>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RemoveAsset;
